/* eslint-disable import/prefer-default-export */
import makeApiCall from './makeApiCall';

export const getHospitalCoverageReport = (params) =>
  makeApiCall(`/htar-crm/dashboard/reports/hospital`, 'GET', params);

export const getHospitalCoverageReportExport = (params) =>
  makeApiCall(`/htar-crm/dashboard/reports/export/hospital`, 'GET', params);
